import React from "react";
import type { MessageOption } from "../types";
import OriStarterPillRow from "./OriStarterPillRow";

/**
 * A starter pill: Coach's own (the options on Ori's newest message) or one of
 * the generic set. Only a generic starter has an id and an icon of its own.
 */
export type StarterPillOption = MessageOption & {
  id?: string;
  Icon?: React.FC<React.SVGProps<SVGSVGElement>>;
};

interface OriStarterPillsProps {
  options: StarterPillOption[];
  onSelect: (option: StarterPillOption, index: number) => void;
  disabled?: boolean;
}

/** The starter row under Ori's message or the welcome, whichever set it is. */
const OriStarterPills: React.FC<OriStarterPillsProps> = ({
  options,
  onSelect,
  disabled = false,
}) => (
  <OriStarterPillRow
    testId="ori-dynamic-starters"
    items={options.map((option, index) => ({
      key: option.id ?? String(index),
      label: option.label,
      // A generic starter is found by its id, whatever the shuffle did.
      testId: option.id
        ? `ori-starter-${option.id}`
        : `ori-dynamic-starter-${index}`,
      Icon: option.Icon,
    }))}
    onSelect={(index) => onSelect(options[index], index)}
    disabled={disabled}
  />
);

export default OriStarterPills;
